import { render, staticRenderFns } from "./mobileSchemeView.vue?vue&type=template&id=36cc07bc&scoped=true"
import script from "./mobileSchemeView.vue?vue&type=script&lang=js"
export * from "./mobileSchemeView.vue?vue&type=script&lang=js"
import style0 from "./mobileSchemeView.vue?vue&type=style&index=0&id=36cc07bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc07bc",
  null
  
)

export default component.exports